<template>
  <asc-container class="asc-anser-tool-template">
    <template slot="header">
      <div
        v-if="signatures.length"
        :class="[
          'asc-anser-tool-template--header',
          signatures.length === 1 ? 'mb-4' : 'mb-2',
        ]"
      >
        Select a platform to see the analytics developer results.
      </div>
      <asc-no-data v-else></asc-no-data>
    </template>
    <asc-platform-tiles-Wrapper
      :signatures="signatures"
      :loading="loading"
      @onPlatformSelect="handlePlatFormSelect"
    />
  </asc-container>
</template>

<script>
import AscContainer from '@/components/atoms/AscContainer'
import AscPlatformTilesWrapper from '@/components/organisms/AscPlatformTilesWrapper'
import AscNoData from '@/components/atoms/AscNoData'

export default {
  name: 'AscAnserToolTemplate',

  components: {
    AscContainer,
    AscPlatformTilesWrapper,
    AscNoData,
  },

  props: {
    signatures: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handlePlatFormSelect(event, value) {
      this.$emit('onPlatformSelect', event, value)
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-anser-tool-template {
  &--header {
    color: $primary-black;
    font-size: 14px;
    line-height: 22px;
  }
}
</style>
